import { defineStore } from 'pinia';

export const FEATURES_NAMESPACE_STRING = '4633cae1-4fa9-505b-97a2-52cbe79bae8e';

export interface Feature {
  key: string;
  value: unknown;
}

export interface FeaturesState {
  list: Feature[];
  listItem: Feature[];
}

export const useFeaturesStore = defineStore('featuresStore', {
  state: (): FeaturesState => ({
    list: [],
    listItem: [],
  }),
  actions: {
    initialize(data: any) {
      if (!data) {
        return;
      }

      this.$patch({ list: data });
    },
    initializeItem(data: any) {
      if (!data) {
        return;
      }

      this.$patch({ listItem: data });
    },
  },
});
